export const SET_WEIGHT_TOLERANCES = 'SET_WEIGHT_TOLERANCES'



// WEBPACK FOOTER //
// ./src/types/weightTolerance.js